// Visuels externes (api-sports.io) : garde de surface, miroir du helper backend `media.py`.
// La décision « peut-on rendre un média externe ici ? » vit ici une seule fois.
export const ALLOWED_SURFACES = new Set(["player_page", "club_page", "watchlist", "search", "leaderboard", "my_collection", "admin"]);

export function canRenderExternalMedia(surface) {
  return ALLOWED_SURFACES.has(surface);
}

export const WATCHLIST_PAGE_SIZE = 24;
